import { defineStore } from 'pinia';
import { useClientState } from './client/state';
import { useClientStatic } from './client/static';
import { useCart } from './client/cart';
import { useCartWatch } from './client/cart-watch';
import { useClientRoute } from './client/route';
import { useClientRequest } from './client/request';
import { useStoreEvents } from './client/events';
import { extractStore } from './shared/extract-store';

export const useClientStore = defineStore('clinet', () => {
    return {
        ...extractStore(useClientState()), // Settings, monetary, session.
        ...extractStore(useClientStatic()),
        ...extractStore(useCart()),
        ...extractStore(useCartWatch()),
        ...extractStore(useClientRoute()),
        ...extractStore(useClientRequest()),
        ...extractStore(useStoreEvents()),
    }
})